module.exports = __webpack_public_path__ + "static/img/30.5222d36c.png";